export default function (input) {
  return input.replace('<p>', '').replace('</p>', '').replace('<br>', '');
}
